import React from 'react';
import { Embed } from 'semantic-ui-react';
import { createComponent } from "../../../wayin-react";
import { getVimeoId } from "../../../util";
var VimeoVideo = createComponent({
  displayName: 'VimeoVideo',
  render: function render(_ref) {
    var src = _ref.src,
        id = _ref.id;

    if (!id) {
      id = getVimeoId(src);
    }

    return /*#__PURE__*/React.createElement(Embed, {
      id: id,
      source: "vimeo",
      active: true,
      autoplay: false
    });
  }
});
export default VimeoVideo;
//# sourceMappingURL=vimeo-video.js.map